import { createContext, useContext } from 'react';
import { GridState } from './GridState';
import { assertContextValue } from '../../createContext';

export const VirtualVirtualGridStateContext = createContext<GridState | null>(
  null,
);

export const VirtualGridStateProvider = VirtualVirtualGridStateContext.Provider;
export const VirtualGridStateConsumer = VirtualVirtualGridStateContext.Consumer;

export const useVirtualGridStateContext = () => {
  const value = useContext(VirtualVirtualGridStateContext);
  assertContextValue('VirtualGridStateProvider', value);
  return value;
};
